<div class="flex flex-1 flex-col overflow-hidden">
  <div class="w-full relative">
    @if (isLoading()) {
      <div class="w-full absolute">
        <mat-progress-bar
          data-cy="storage-config-loader"
          class="mds-x-small"
          [mode]="'indeterminate'"
        ></mat-progress-bar>
      </div>
    }
  </div>

  @if (showStorageMessage()) {
    <div class="w-full mb-4">
      <modus-alert
        class="w-full"
        [message]="storageMessage()"
        [type]="storageMessageType()"
      ></modus-alert>
    </div>
  }

  <div class="flex flex-1 flex-col overflow-hidden p-4 bg-white border border-gray-0 rounded">
    @if (projectQuotaView(); as quota) {
      <div class="flex flex-row items-center">
        <!-- title -->
        <div class="flex flex-1 flex-wrap">
          <span class="font-semibold text-lg mr-4">{{ title() }}</span>
          <div
            class="flex items-center px-2 bg-green-light font-semibold text-white rounded-md"
            [ngClass]="storageUsedBackgroundColor()"
          >
            {{ quota.quotaUsedByAccountDisplayValue }}
          </div>
        </div>

        @if (primaryAccount(); as account) {
          <div class="flex flex-1 flex-wrap text-sm">
            <span class="font-semibold mr-1">{{ account.name }}</span>
            {{ translations.accountId.text }}: {{ account.accountId }}
          </div>
        }

        <!-- usage -->
        <div class="flex flex-1 flex-wrap justify-end text-sm">
          <div class="flex whitespace-nowrap">
            <span class="font-semibold mr-1">{{ translations.storageUsed.total.text }}:</span>
            {{ quota.quotaUsedByAccount | fileSize }}
          </div>
          <div class="flex whitespace-nowrap ml-6">
            <span class="font-semibold mr-1">{{ translations.storageAvailable.text }}:</span>
            {{ quota.quota | fileSize }}
          </div>
        </div>
      </div>

      <!-- usage graph -->
      <div class="w-full pt-4">
        <sd-usage-bar
          [usageValueBackground]="{
            label: translations.storageUsed.allProjects.text,
            value: quota.quotaUsedByAccountDisplayValue,
            percentage: quota.quotaUsedByAccountPercent,
          }"
          [usageValueForeground]="{
            label: translations.storageUsed.currentProject.text,
            value: quota.quotaUsedByProjectDisplayValue,
            percentage: quota.quotaUsedByProjectPercent,
          }"
          class="border-1"
        ></sd-usage-bar>
      </div>

      <!-- project usages -->
      <div class="font-semibold pt-4">
        {{ translations.storageUsedByPojects.title.text }}
      </div>

      <sd-project-usage-table
        class="h-full overflow-y-scroll mt-2"
        [projectUsages]="quota.quotaUsagesByProject"
        [connectUrl]="connectUrl()"
      ></sd-project-usage-table>
    }
  </div>
</div>
